import msalConfig from './AuthServiceConfig';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import router from '@/router';
  
export const msalInstance = new PublicClientApplication(msalConfig);

export async function initialize() {
  const request = {
    scopes: msalConfig.resources.api.resourceScope
  };

  await msalInstance.initialize();

  let tokenResponse = await msalInstance.handleRedirectPromise();  
  const accounts = msalInstance.getAllAccounts();

  if (!accounts.length) {
    tokenResponse = await msalInstance.loginRedirect(request);
  }

  else if (accounts.length === 1) {
    msalInstance.setActiveAccount(accounts[0]);

    tokenResponse = await msalInstance.acquireTokenSilent({ ...request, forceRefresh: false }).catch(async (error) => {
      return await msalInstance.acquireTokenPopup(request);
    });
  }

  else {
    tokenResponse = await msalInstance.acquireTokenPopup({
      ...request,
      prompt: 'select_account'
    });
  }

  // Check that the tenant ID is allowed
  validateTokenIssuer(tokenResponse);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload;
    const account = payload.account;

    msalInstance.setActiveAccount(account);
  }
})

function validateTokenIssuer(payload) {
  // Check that the tenant ID is allowed
  const allowedTenantIds = msalConfig.auth.allowedTenantIds;

  if (!allowedTenantIds.includes(payload.tenantId)) {
    if (router.currentRoute.path !== '/error') {
      router.push({ path: '/error', query: { code: 'invalid_tenant', email: payload.account?.username, tenantId: payload.tenantId } });
    }

    throw `Tenant ID ${payload.tenantId} is not allowed`;
  }
}
